import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "5c3f9675-3238-44fa-8f21-f48a0d2f8acb",
  publicId: "4",
  name: "Equation of acoustics and their solutions in the frequency domain – Stationary waves, SWR",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },

  body: [principle01, task01, task02],
};

export default lesson;
